module.exports = __webpack_public_path__ + "img/DeleteBlueIcon.01397c73.svg";